import { IConfigWeb, IResponseConfigWeb } from '../types';
import { transformToHexColorString } from '~/utils/formatter';

export const configWebDataCast = (data: IResponseConfigWeb): IConfigWeb => {
  const colors = data.colors;
  const images = data.images;
  const config = data.configuration;

  return {
    colors: {
      headerBackgroundFirstColor: colors.header_background1 || '',
      headerBackgroundSecondColor: colors.header_background2 || '',
      headerPlaneTextColor: colors.header_plane_text || '',
      headerBackgroundSelectedColor: colors.header_highlighted_background || '',
      headerBackgroundSelectedTextColor: colors.header_highlighted_background_text || '',
      buttonsColor: colors.highlighted_buttons_color || '',
      buttonsTextColor: colors.buttons_text_color || '',
      css: colors.custom_css || '',
    },
    images: {
      bannerImage: images.banner || '',
      appBannerIcon: images.logo || '',
      webHeaderLogo: images.app_header_logo || '',
      webFooterLogo: images.app_banner_logo || '',
      favicon: images.favicon || '',
    },
    configuration: {
      is_human_readable_url: config.is_human_readable_url,
      defaultLanguage: config.default_language,
      webContact: {
        businessName: { en: config.restaurant_name_en, ar: config.restaurant_name_ar },
        email: config.email,
        mobile: config.mobile,
        isMobileHidden: config.hide_mobile_number,
        copyright: config.copyright || '',
        address: config.address || '',
      },
      metaDetails: {
        keyword: { en: config.meta_keyword || '', ar: config.meta_keyword_ar || '' },
        description: { en: config.meta_description || '', ar: config.meta_description_ar || '' },
      },
      appLinks: {
        ios: config.app_ios || '',
        android: config.app_android || '',
        oneLink: config.one_link || '',
      },
      socialLinks: {
        facebook: config.facebook || '',
        instagram: config.instagram || '',
        twitter: config.twitter || '',
        whatsApp: config.whatsapp || '',
        youtube: config.youtube || '',
        tiktok: config.tiktok || '',
        snapchat: config.snapchat || '',
      },
    },
  };
};

export const getConfigWebParams = (currentData: IConfigWeb, previousData: IConfigWeb) => {
  const curColors = currentData.colors;
  const curImages = currentData.images;
  const curConfig = currentData.configuration;

  const prevImages = previousData.images;

  return {
    // colors
    header_background1: transformToHexColorString(curColors.headerBackgroundFirstColor),
    header_background2: transformToHexColorString(curColors.headerBackgroundSecondColor),
    header_plane_text: transformToHexColorString(curColors.headerPlaneTextColor),
    header_highlighted_background: transformToHexColorString(curColors.headerBackgroundSelectedColor),
    header_highlighted_background_text: transformToHexColorString(curColors.headerBackgroundSelectedTextColor),
    highlighted_buttons_color: transformToHexColorString(curColors.buttonsColor),
    buttons_text_color: transformToHexColorString(curColors.buttonsTextColor),
    custom_css: curColors.css,
    // images
    banner: prevImages.bannerImage === curImages.bannerImage ? undefined : curImages.bannerImage || null,
    app_header_logo: prevImages.webHeaderLogo === curImages.webHeaderLogo ? undefined : curImages.webHeaderLogo || null,
    app_banner_logo: prevImages.webFooterLogo === curImages.webFooterLogo ? undefined : curImages.webFooterLogo || null,
    logo: prevImages.appBannerIcon === curImages.appBannerIcon ? undefined : curImages.appBannerIcon || null,
    favicon: prevImages.favicon === curImages.favicon ? undefined : curImages.favicon || null,
    // time picker
    default_language: curConfig.defaultLanguage,
    // web contact
    restaurant_name_en: curConfig.webContact.businessName.en,
    restaurant_name_ar: curConfig.webContact.businessName.ar,
    email: curConfig.webContact.email,
    mobile: `${curConfig.webContact.mobile[0] === '+' ? '' : '+'}${curConfig.webContact.mobile}`,
    hide_mobile_number: curConfig.webContact.isMobileHidden,
    copyright: curConfig.webContact.copyright || null,
    address: curConfig.webContact.address || null,
    // meta details
    meta_keyword: curConfig.metaDetails.keyword.en || null,
    meta_keyword_ar: curConfig.metaDetails.keyword.ar || null,
    meta_description: curConfig.metaDetails.description.en || null,
    meta_description_ar: curConfig.metaDetails.description.ar || null,
    // app links
    app_ios: curConfig.appLinks.ios || null,
    app_android: curConfig.appLinks.android || null,
    one_link: curConfig.appLinks.oneLink || null,
    is_human_readable_url: curConfig.is_human_readable_url,
    // social links
    facebook: curConfig.socialLinks.facebook || null,
    instagram: curConfig.socialLinks.instagram || null,
    twitter: curConfig.socialLinks.twitter || null,
    whatsapp: curConfig.socialLinks.whatsApp || null,
    youtube: curConfig.socialLinks.youtube || null,
    tiktok: curConfig.socialLinks.tiktok || null,
    snapchat: curConfig.socialLinks.snapchat || null,
  };
};
